import { APPLICANT_LIVING_SITUATION, LIABILITY_TYPE, PROPERTY_CONSTRUCTION_TYPE, PROPERTY_GARAGE_SIZE, PROPERTY_OCCUPANCY_TYPE, PROPERTY_RENTAL_INCOME } from "@Shared/@Types/application/application-enums";
export const APPLICATION_VISIBILITY_TOGGLES = {
  "[property][styles][garage-style]": {
    isVisibleWhen: {
      "[property][styles][garage-size]": {
        hasValues: [PROPERTY_GARAGE_SIZE.SINGLE, PROPERTY_GARAGE_SIZE.DOUBLE, PROPERTY_GARAGE_SIZE.TRIPLE]
      }
    }
  },
  "[property][styles][structure-age]": {
    isVisibleWhen: {
      "[property][styles][construction-type]": {
        hasValues: [PROPERTY_CONSTRUCTION_TYPE.EXISTING]
      }
    }
  },
  "[property][costs][rental-income-options-percent]": {
    isVisibleWhen: {
      "[property][costs][rental-income-options]": {
        hasValues: [PROPERTY_RENTAL_INCOME.ADD_PERC_TO_GROSS_INCOME]
      }
    }
  },
  "[property][costs][heating]": {
    isVisibleWhen: {
      "[property][costs][fees-include-heat]": {
        hasValues: [false, null]
      }
    }
  },
  "[property][details][monthly-income]": {
    isVisibleWhen: {
      "[property][details][rental-property]": {
        hasValues: [true]
      }
    }
  },
  "[property][existing-mortgages][mortgage-insurance-provider-id]": {
    isVisibleWhen: {
      "[property][existing-mortgages][insured]": {
        hasValues: [true]
      }
    }
  },
  "[property][existing-mortgages][insurance-account-number]": {
    isVisibleWhen: {
      "[property][existing-mortgages][insured]": {
        hasValues: [true]
      }
    }
  },
  "[main-applicant][personal-details][monthly-rent]": {
    isVisibleWhen: {
      "[main-applicant][personal-details][own]": {
        hasValues: [APPLICANT_LIVING_SITUATION.RENT]
      }
    }
  },
  "[main-applicant][employment][operating-as]": {
    isVisibleWhen: {
      "[main-applicant][employment][self-employed]": {
        hasValues: [true]
      }
    }
  },
  "[main-applicant][employment][gross-revenue]": {
    isVisibleWhen: {
      "[main-applicant][employment][self-employed]": {
        hasValues: [true]
      }
    }
  },
  "[main-applicant][liabilities][limit]": {
    isVisibleWhen: {
      "[main-applicant][liabilities][type]": {
        hasValues: [LIABILITY_TYPE.CREDIT_CARD, LIABILITY_TYPE.SECURED_LINE_OF_CREDIT, LIABILITY_TYPE.UNSECURED_LINE_OF_CREDIT]
      }
    }
  },
  "[main-applicant][other-properties][property-rental][monthly-income]": {
    isVisibleWhen: {
      "[main-applicant][other-properties][property-rental][occupancy]": {
        hasValues: [PROPERTY_OCCUPANCY_TYPE.RENTAL, PROPERTY_OCCUPANCY_TYPE.OWNER_OCCUPIED_AND_RENTAL]
      }
    }
  },
  "[main-applicant][other-properties][property-rental][rental-income-options]": {
    isVisibleWhen: {
      "[main-applicant][other-properties][property-rental][occupancy]": {
        hasValues: [PROPERTY_OCCUPANCY_TYPE.RENTAL, PROPERTY_OCCUPANCY_TYPE.OWNER_OCCUPIED_AND_RENTAL]
      }
    }
  },
  "[main-applicant][other-properties][property-rental][rental-income-options-percent]": {
    isVisibleWhen: {
      "[main-applicant][other-properties][property-rental][occupancy]": {
        hasValues: [PROPERTY_OCCUPANCY_TYPE.RENTAL, PROPERTY_OCCUPANCY_TYPE.OWNER_OCCUPIED_AND_RENTAL]
      }
    }
  },
  "[main-applicant][other-properties][property-rental][hydro]": {
    isVisibleWhen: {
      "[main-applicant][other-properties][property-rental][occupancy]": {
        hasValues: [PROPERTY_OCCUPANCY_TYPE.RENTAL, PROPERTY_OCCUPANCY_TYPE.OWNER_OCCUPIED_AND_RENTAL]
      }
    }
  },
  "[main-applicant][other-properties][property-rental][management]": {
    isVisibleWhen: {
      "[main-applicant][other-properties][property-rental][occupancy]": {
        hasValues: [PROPERTY_OCCUPANCY_TYPE.RENTAL, PROPERTY_OCCUPANCY_TYPE.OWNER_OCCUPIED_AND_RENTAL]
      }
    }
  },
  "[main-applicant][other-properties][property-rental][repairs]": {
    isVisibleWhen: {
      "[main-applicant][other-properties][property-rental][occupancy]": {
        hasValues: [PROPERTY_OCCUPANCY_TYPE.RENTAL, PROPERTY_OCCUPANCY_TYPE.OWNER_OCCUPIED_AND_RENTAL]
      }
    }
  },
  "[main-applicant][other-properties][property-rental][others]": {
    isVisibleWhen: {
      "[main-applicant][other-properties][property-rental][occupancy]": {
        hasValues: [PROPERTY_OCCUPANCY_TYPE.RENTAL, PROPERTY_OCCUPANCY_TYPE.OWNER_OCCUPIED_AND_RENTAL]
      }
    }
  },
  "[main-applicant][other-properties][property-rental][insurance]": {
    isVisibleWhen: {
      "[main-applicant][other-properties][property-rental][occupancy]": {
        hasValues: [PROPERTY_OCCUPANCY_TYPE.RENTAL, PROPERTY_OCCUPANCY_TYPE.OWNER_OCCUPIED_AND_RENTAL]
      }
    }
  },
  "[main-applicant][other-properties][property-rental][interest]": {
    isVisibleWhen: {
      "[main-applicant][other-properties][property-rental][occupancy]": {
        hasValues: [PROPERTY_OCCUPANCY_TYPE.RENTAL, PROPERTY_OCCUPANCY_TYPE.OWNER_OCCUPIED_AND_RENTAL]
      }
    }
  },
  "[main-applicant][other-properties][property-costs][heating]": {
    isVisibleWhen: {
      "[main-applicant][other-properties][property-costs][fees-include-heat]": {
        hasValues: [false, null]
      }
    }
  },
  "[co-applicants][employment][operating-as]": {
    isVisibleWhen: {
      "[co-applicants][employment][self-employed]": {
        hasValues: [true]
      }
    }
  },
  "[co-applicants][employment][gross-revenue]": {
    isVisibleWhen: {
      "[co-applicants][employment][self-employed]": {
        hasValues: [true]
      }
    }
  },
  "[co-applicants][liabilities][limit]": {
    isVisibleWhen: {
      "[co-applicants][liabilities][type]": {
        hasValues: [LIABILITY_TYPE.CREDIT_CARD, LIABILITY_TYPE.SECURED_LINE_OF_CREDIT, LIABILITY_TYPE.UNSECURED_LINE_OF_CREDIT]
      }
    }
  },
  "[co-applicants][other-properties][property-rental][monthly-income]": {
    isVisibleWhen: {
      "[co-applicants][other-properties][property-rental][occupancy]": {
        hasValues: [PROPERTY_OCCUPANCY_TYPE.RENTAL, PROPERTY_OCCUPANCY_TYPE.OWNER_OCCUPIED_AND_RENTAL]
      }
    }
  },
  "[co-applicants][other-properties][property-rental][rental-income-options]": {
    isVisibleWhen: {
      "[co-applicants][other-properties][property-rental][occupancy]": {
        hasValues: [PROPERTY_OCCUPANCY_TYPE.RENTAL, PROPERTY_OCCUPANCY_TYPE.OWNER_OCCUPIED_AND_RENTAL]
      }
    }
  },
  "[co-applicants][other-properties][property-rental][rental-income-options-percent]": {
    isVisibleWhen: {
      "[co-applicants][other-properties][property-rental][occupancy]": {
        hasValues: [PROPERTY_OCCUPANCY_TYPE.RENTAL, PROPERTY_OCCUPANCY_TYPE.OWNER_OCCUPIED_AND_RENTAL]
      }
    }
  },
  "[co-applicants][other-properties][property-rental][hydro]": {
    isVisibleWhen: {
      "[co-applicants][other-properties][property-rental][occupancy]": {
        hasValues: [PROPERTY_OCCUPANCY_TYPE.RENTAL, PROPERTY_OCCUPANCY_TYPE.OWNER_OCCUPIED_AND_RENTAL]
      }
    }
  },
  "[co-applicants][other-properties][property-rental][management]": {
    isVisibleWhen: {
      "[co-applicants][other-properties][property-rental][occupancy]": {
        hasValues: [PROPERTY_OCCUPANCY_TYPE.RENTAL, PROPERTY_OCCUPANCY_TYPE.OWNER_OCCUPIED_AND_RENTAL]
      }
    }
  },
  "[co-applicants][other-properties][property-rental][repairs]": {
    isVisibleWhen: {
      "[co-applicants][other-properties][property-rental][occupancy]": {
        hasValues: [PROPERTY_OCCUPANCY_TYPE.RENTAL, PROPERTY_OCCUPANCY_TYPE.OWNER_OCCUPIED_AND_RENTAL]
      }
    }
  },
  "[co-applicants][other-properties][property-rental][others]": {
    isVisibleWhen: {
      "[co-applicants][other-properties][property-rental][occupancy]": {
        hasValues: [PROPERTY_OCCUPANCY_TYPE.RENTAL, PROPERTY_OCCUPANCY_TYPE.OWNER_OCCUPIED_AND_RENTAL]
      }
    }
  },
  "[co-applicants][other-properties][property-rental][insurance]": {
    isVisibleWhen: {
      "[co-applicants][other-properties][property-rental][occupancy]": {
        hasValues: [PROPERTY_OCCUPANCY_TYPE.RENTAL, PROPERTY_OCCUPANCY_TYPE.OWNER_OCCUPIED_AND_RENTAL]
      }
    }
  },
  "[co-applicants][other-properties][property-rental][interest]": {
    isVisibleWhen: {
      "[co-applicants][other-properties][property-rental][occupancy]": {
        hasValues: [PROPERTY_OCCUPANCY_TYPE.RENTAL, PROPERTY_OCCUPANCY_TYPE.OWNER_OCCUPIED_AND_RENTAL]
      }
    }
  },
  "[co-applicants][other-properties][property-costs][heating]": {
    isVisibleWhen: {
      "[co-applicants][other-properties][property-costs][fees-include-heat]": {
        hasValues: [false, null]
      }
    }
  },
  "[co-applicants][personal-details][monthly-rent]": {
    isVisibleWhen: {
      "[co-applicants][personal-details][own]": {
        hasValues: [APPLICANT_LIVING_SITUATION.RENT]
      }
    }
  }
};